"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _NotificationsOff = _interopRequireDefault(require("@insided/destination/icons/NotificationsOff"));

var _Notifications = _interopRequireDefault(require("@insided/destination/icons/Notifications"));

var _subscriptionService = require("@insided/shared/services/subscriptionService");

var _actionService = require("../../../services/actionService");

var _classnames = _interopRequireDefault(require("classnames"));

var _SubtleButton = _interopRequireDefault(require("@insided/shared/uikit/SubtleButton"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Follow = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Follow, _Component);

  var _super = _createSuper(Follow);

  function Follow() {
    var _this;

    (0, _classCallCheck2.default)(this, Follow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isSubscribed: _this.props.isSubscribed,
      isLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function (e) {
      e.preventDefault();
      var isGuestUser = _this.props.isGuestUser;

      if (isGuestUser) {
        (0, _actionService.showLoginModal)();
        return;
      }

      _this.toggleSubscription();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleSubscription", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$state, isSubscribed, isLoading, id;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, isSubscribed = _this$state.isSubscribed, isLoading = _this$state.isLoading;
              id = _this.props.id;

              if (!isLoading) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              _this.setState(function (prevState) {
                return {
                  isLoading: true,
                  isSubscribed: !prevState.isSubscribed
                };
              });

              _context.prev = 5;

              if (!isSubscribed) {
                _context.next = 11;
                break;
              }

              _context.next = 9;
              return (0, _subscriptionService.unsubscribeTopic)(id);

            case 9:
              _context.next = 13;
              break;

            case 11:
              _context.next = 13;
              return (0, _subscriptionService.subscribeTopic)(id);

            case 13:
              _context.next = 19;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](5);

              _this.setState(function (prevState) {
                return {
                  isSubscribed: !prevState.isSubscribed
                };
              });

              console.error(_context.t0);

            case 19:
              _context.prev = 19;

              _this.setState({
                isLoading: false
              });

              return _context.finish(19);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 15, 19, 22]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(Follow, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          isSubscribed = _this$state2.isSubscribed,
          isLoading = _this$state2.isLoading;
      return (0, _preact.h)(_SubtleButton.default, {
        className: (0, _classnames.default)('action-btn--follow', {
          active: isSubscribed
        }),
        startIcon: isSubscribed ? (0, _preact.h)(_NotificationsOff.default, {
          width: 16,
          height: 16
        }) : (0, _preact.h)(_Notifications.default, {
          width: 16,
          height: 16
        }),
        isLoading: isLoading,
        onClick: this.handleClick,
        title: (0, _preact.h)(_phrase.default, {
          key: Number(isSubscribed),
          p: "topic.actions.".concat(isSubscribed ? 'unfollow' : 'follow')
        })
      });
    }
  }]);
  return Follow;
}(_preact.Component);

var _default = Follow;
exports.default = _default;